<template lang="pug">

  div

    //-
      -
      - Modal EDITAR ESCALA
      -
      -

    v-dialog(v-model="isVisible" max-width="550px" width="100%" persistent)

      .dialogHeader

        .dialogHeaderTitle
          | Alterar detalhes da escala

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="close(false)")

      .dialogBody

        .dialogBodyContent

          .groupTabs

            group-tab(@click="() => setTab('general')" tabName="general" tabTitle="Geral" tabIcon="mdi-information" :active="groupTab === 'general'" :loading="loading" :smaller="true")
            group-tab(@click="() => setTab('compensation')" tabName="compensation" tabTitle="Remuneração" tabIcon="mdi-cash-clock" :active="groupTab === 'compensation'" :loading="loading" :smaller="true")
            group-tab(@click="() => setTab('duties')" tabName="duties" tabTitle="Plantões" tabIcon="mdi-calendar-clock" :active="groupTab === 'duties'" :loading="loading" :smaller="true")
            //- [staging-portaltelemedicina / master-portaltelemedicina]
            //- group-tab(@click="() => setTab('consultations')" tabName="consultations" tabTitle="Consultas" tabIcon="mdi-hospital-box-outline" :active="groupTab === 'consultations'" :loading="loading" :smaller="true")
            //- [staging-portaltelemedicina / master-portaltelemedicina]

          .groupTabBody.groupTabBody--child(v-if="groupTab === 'general'")

            settings-section(title="Informações" :divide="false" :informations="[{ title: 'Nome da escala:', message: 'Será usado para identificar plantões por escala nas funcionalidades do sistema' }, { title: 'Local:', message: 'Local do grupo que será vinculado aos plantões dessa escala.<br />Plantonistas podem ser obrigados a bater ponto dentro do local quando o mesmo tem uma cerca geográfica.' }]")

            .createTurnField.createTurnField--first
              label.csLabel Nome da escala
              div
                input(v-model="scaleName" :disabled="loading" class="sosInput" maxlength="64" placeholder="Entre 1 e 64 caracteres")

            .fieldError(v-if="error.name")
              | Digite um nome de até 64 caracteres.

            template(v-if="presetLocations")

              .createTurnField
                sos-select(label="Local" :fullscreen="true" fullscreenTitle="Locais" :fullscreenAutoWidth="true" :items="groupLocations" @sosSelectChanged="selectedScaleLocation" :default="scaleLocation.id" :disabled="loading")

              span.fieldNote
                b Nota:
                |  O grupo tem locais pré-definidos. Clique no campo acima para escolher um local.

            template(v-else)

              .createTurnField
                label.csLabel Local
                div
                  input(v-model="scaleLocation.name" :disabled="loading" class="sosInput" maxlength="64" placeholder="Deixe vazio ou informe um local entre 3 e 64 caracteres")

              span.fieldNote
                b Nota:
                |  O grupo não tem locais pré-definidos. Você pode informar um local personalizado.

            .fieldError(v-if="error.local")
              | Limpe o nome do local ou digite um nome de 3 a 64 caracteres.

            settings-section(title="Período")

            .createTurnField.createTurnField--first
              label.csLabel Dia de início da escala no mês
              div
                input(v-model="startDayOfMonth" :disabled="loading" class="sosInput" maxlength="2" placeholder="Deixe vazio ou informe um dia do mês" @input="onScaleStartDayOfMonth(startDayOfMonth)")

            .fieldError(v-if="error.startDay")
              | Informe um número entre 1 e 31

            .createTurnField.createTurnField--last
              label.csLabel Dia de término da escala no mês seguinte
              div
                input(v-model="endDayOfMonth" :disabled="loading" class="sosInput" maxlength="2" placeholder="Deixe vazio ou informe um dia do mês" @input="onScaleEndDayOfMonth(endDayOfMonth)")

            .fieldError(v-if="error.endDay")
              | Informe um número entre 1 e 31

          .groupTabBody.groupTabBody--child(v-if="groupTab === 'compensation'")

            settings-section(title="Valor padrão / único" :divide="false")

            .createTurnField.createTurnField--first.createTurnField--last
              label.csLabel Valor hora
              div
                app-money-light(:value="scaleValue" :blur-event="onBlurScaleValue" :disabled="loading")

            settings-section(title="Valor por dia da semana")

            .createTurnFieldsGroup

              .createTurnField.createTurnField--50.createTurnField--first.createTurnField--last
                label.csLabel Segunda a Sexta
                div
                  app-money-light(:value="scaleWeekdaysHourlyRate" @input="onInputScaleWeekdaysHourlyRate" :blur-event="() => {}" :disabled="loading || scaleDayShiftHourlyRate > 0.00 || scaleNightShiftHourlyRate > 0.00")

              .createTurnField.createTurnField--50.createTurnField--first.createTurnField--last
                label.csLabel Fim de semana
                div
                  app-money-light(:value="scaleWeekendHourlyRate" @input="onInputScaleWeekendHourlyRate" :blur-event="() => {}" :disabled="loading || scaleDayShiftHourlyRate > 0.00 || scaleNightShiftHourlyRate > 0.00")

            settings-section(title="Valor por turno")

            .createTurnFieldsGroup

              .createTurnField.createTurnField--50.createTurnField--first.createTurnField--last
                label.csLabel Diurno
                div
                  app-money-light(:value="scaleDayShiftHourlyRate" @input="onInputScaleDayShiftHourlyRate" :blur-event="() => {}" :disabled="loading || scaleWeekdaysHourlyRate > 0.00 || scaleWeekendHourlyRate > 0.00")

              .createTurnField.createTurnField--50.createTurnField--first.createTurnField--last
                label.csLabel Noturno
                div
                  app-money-light(:value="scaleNightShiftHourlyRate" @input="onInputScaleNightShiftHourlyRate" :blur-event="() => {}" :disabled="loading || scaleWeekdaysHourlyRate > 0.00 || scaleWeekendHourlyRate > 0.00")

            settings-section(title="Valor por dia da semana e turno")

            .createTurnFieldsGroup

              .createTurnField.createTurnField--50.createTurnField--first.createTurnField--last
                label.csLabel Segunda a Sexta - Diurno
                div
                  app-money-light(:value="scaleWeekdaysDayShiftHourlyRate" @input="onInputScaleWeekdaysDayShiftHourlyRate" :blur-event="() => {}" :disabled="loading")

              .createTurnField.createTurnField--50.createTurnField--first.createTurnField--last
                label.csLabel Segunda a Sexta - Noturno
                div
                  app-money-light(:value="scaleWeekdaysNightShiftHourlyRate" @input="onInputScaleWeekdaysNightShiftHourlyRate" :blur-event="() => {}" :disabled="loading")

            .createTurnFieldsGroup

              .createTurnField.createTurnField--50.createTurnField--last
                label.csLabel Fim de semana - Diurno
                div
                  app-money-light(:value="scaleWeekendDayShiftHourlyRate" @input="onInputScaleWeekendDayShiftHourlyRate" :blur-event="() => {}" :disabled="loading")

              .createTurnField.createTurnField--50.createTurnField--last
                label.csLabel Fim de semana - Noturno
                div
                  app-money-light(:value="scaleWeekendNightShiftHourlyRate" @input="onInputScaleWeekendNightShiftHourlyRate" :blur-event="() => {}" :disabled="loading")

          .groupTabBody.groupTabBody--child(v-if="groupTab === 'duties'")

            settings-section(title="Ações" :divide="false")

            .settingItem.settingItem--clean
              .settingItemName Plantão com intervalo
              sos-switch(:value="allowBreakDuringDuty" @click="onToggleDutyBreak" :disabled="loading")

            settings-section(title="Visualização" :informations="[{ title: 'Cor dos plantões livres e Cor dos plantões assumidos:', message: 'Define as cores dos cartões dos plantões exibidos no calendário da escala e plantões do grupo' }]")

            .settingItem
              .settingItemName Cor dos plantões livres:
              .colorPickerButton(@click="openAvailableShiftsColorPicker" :style="{ 'background-color': colorShiftsAvailable }")

            .fieldError.mt-4(v-if="error.availableShiftsColor")
              | Escolha uma cor para os plantões disponiveis.
            .fieldError.mt-4(v-if="error.availableShiftWhite")
              | A cor é muito clara! Escolha um tom mais escuro.
            .fieldError.mt-4(v-if="error.sameShiftsColor && (!error.availableShiftWhite && !error.ownedShiftWhite)")
              | Escolha uma cor diferente para plantões disponíveis e assumidos.

            .settingItem.settingItem--clean
              .settingItemName Cor dos plantões assumidos:
              .colorPickerButton(@click="openOwnedShiftsColorPicker" :style="{ 'background-color': colorShiftsOwned }")

            .fieldError.mt-4(v-if="error.ownedShiftsColor")
              | Escolha uma cor para os plantões assumidos.
            .fieldError.mt-4(v-if="error.ownedShiftWhite")
              | A cor é muito clara! Escolha um tom mais escuro.

            settings-section(title="Limites" :informations="[{ title: 'Número máximo de plantões por usuário:', message: 'Determina quantos plantões por mês o plantonista pode receber via transferência' }]")

            .createTurnField.createTurnField--first.createTurnField--last
              label.csLabel Número máximo de plantões por usuário
              div
                input(v-model="scaleMaxShifts" :disabled="loading" class="sosInput" maxlength="4" placeholder="Deixe vazio ou informe uma quantidade de 1 a 9999" @input="onScaleMaxShiftsChange(scaleMaxShifts)")

            .fieldError(v-if="error.maxShifts")
              | Limpe o campo ou digite uma quantidade menor que 9999.

          //- [staging-portaltelemedicina / master-portaltelemedicina]
          //- .groupTabBody.groupTabBody--smaller(v-if="groupTab === 'consultations'")

            .groupTabs

              group-tab(@click="() => setConsultationsTabChildTab('slots')" tabName="slots" tabTitle="Projeção de vagas" tabIcon="mdi-calendar-plus" :active="consultationsTabChildTab === 'slots'" :loading="false" :smaller="true")
              group-tab(@click="() => setConsultationsTabChildTab('patient')" tabName="patient" tabTitle="Pacientes" tabIcon="mdi-account-heart" :active="consultationsTabChildTab === 'patient'" :loading="false" :smaller="true")

            .groupTabBody.groupTabBody--child(v-if="consultationsTabChildTab === 'slots'")

              settings-section(title="Regras" :divide="false" :informations="[{ title: 'Mostrar vagas apenas de plantões assumidos:', message: 'Somente plantões assumidos vão projetar vagas no Portal Consultas' }]")

              .settingItem.settingItem--clean
                .settingItemName Mostrar vagas apenas de plantões assumidos
                sos-switch(:value="slotsFromOwnedDutiesOnly" @click="onToggleSlotsFromOwnedDutiesOnly" :disabled="loading")

              settings-section(title="Consulta" :informations="[{ title: 'Tempo de consulta:', message: 'O tempo ou duração da consulta será atrelado aos plantões livres dessa escala e o Portal Consultas usará o tempo da consulta, início do plantão e duração do plantão para projetar as vagas' }]")

              .createTurnField.createTurnField--first.createTurnField--last(style="position: relative; z-index: 7")
                sos-select(label="Tempo de consulta" :fullscreen="true" fullscreenTitle="Duração da consulta" :fullscreenAutoWidth="true" :items="optionsConsultationDuration" @sosSelectChanged="onSelectConsultationDuration" :default="scaleConsultationDuration" :disabled="loading")

            .groupTabBody.groupTabBody--child(v-if="consultationsTabChildTab === 'patient'")

              settings-section(title="Regras" :divide="false" :informations="[{ title: 'Proibir agendamentos sem paciente:', message: 'Obriga o operador a definir um paciente no agendamento' }]")

              //- Obrigar a inclusão de paciente

              .settingItem.settingItem--clean
                .settingItemName Proibir agendamentos sem paciente
                sos-switch(:value="requirePatient" @click="onSelectPatientRequiredOption" :disabled="loading")
          //- [staging-portaltelemedicina / master-portaltelemedicina]

          .text-right.mt-5
            sos-button(@buttonClick="close(false)" size="medium" buttonLabel="Fechar" buttonIcon="mdi-close" buttonIconSize="16" color="blue" :disabled="loading").mr-3
            sos-button(@buttonClick="saveScale" size="medium" buttonLabel="Atualizar" buttonIcon="mdi-refresh" buttonIconSize="16" color="success" :disabled="loading")

    //-
      -
      - Modal AVISO
      -
      -

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

    //-
      -
      - Modal SOS COLOR PICKER
      -
      -

    sos-color-picker(ref="dialogAvailableColorPicker" @close="onAvailableShiftsColorPickerClose")
    sos-color-picker(ref="dialogOwnedColorPicker" @close="onOwnedShiftsColorPickerClose")

</template>

<script>

  import { isLightColor } from '@/functions'
  import { validateLocationName } from '@/functions/groups'
  import { validateScaleName } from '@/functions/scales'

  import AppMoneyLight from '@/components/base/AppMoneyLight'
  import SettingsSection from '@/components/SettingsSection'
  import SosSelect from '@/components/SosSelect'
  import SosButton from '@/components/SosButton'
  import SosSwitch from '@/components/SosSwitch'
  import ConfirmDialog from '@/modals/ConfirmDialog'
  import SosColorPicker from '@/modals/SosColorPicker'
  import GroupTab from '@/components/GroupTab'

  import { apiUpdateScale } from '@/services/firebase'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  export default {
    name: 'ScaleEdit',

    components: {
      'app-money-light': AppMoneyLight,
      'settings-section': SettingsSection,
      'sos-select': SosSelect,
      'sos-button': SosButton,
      'sos-switch': SosSwitch,
      'confirm-dialog': ConfirmDialog,
      'sos-color-picker': SosColorPicker,
      'group-tab': GroupTab,
    },

    mixins: [
      confirmDialogMixin,
    ],

    data () {
      return {
        isVisible: false,
        loading: false,

        presetLocations: false,
        groupLocations: [],

        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        optionsConsultationDuration: [
          { key: '0', value: '0', text: 'Desativado' },
          { key: '06', value: '6', text: '6 minutos' },
          { key: '10', value: '10', text: '10 minutos' },
          { key: '15', value: '15', text: '15 minutos' },
          { key: '20', value: '20', text: '20 minutos' },
          { key: '30', value: '30', text: '30 minutos' },
          { key: '60', value: '60', text: '60 minutos' },
        ],
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        error: {
          name: false,
          local: false,
          maxShifts: false,
          startDay: false,
          endDay: false,
          availableShiftsColor: false,
          ownedShiftsColor: false,
          sameShiftsColor: false,
          availableShiftWhite: false,
          ownedShiftWhite: false,
        },

        scaleID: '',

        scaleName: '',
        scaleLocation: { id: '', name: '' },
        scaleValue: 0,
        scaleWeekdaysHourlyRate: 0,
        scaleWeekendHourlyRate: 0,
        scaleDayShiftHourlyRate: 0,
        scaleNightShiftHourlyRate: 0,
        scaleWeekdaysDayShiftHourlyRate: 0,
        scaleWeekdaysNightShiftHourlyRate: 0,
        scaleWeekendDayShiftHourlyRate: 0,
        scaleWeekendNightShiftHourlyRate: 0,
        scaleMaxShifts: 0,
        startDayOfMonth: 0,
        endDayOfMonth: 0,

        // startOnMonday: false,

        allowBreakDuringDuty: false,

        colorShiftsAvailable: '#00cb72',
        colorShiftsOwned: '#2196f3',

        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        // --- SOS Portal
        scaleConsultationDuration: '0',
        requirePatient: true,
        // requirePatient: '1',
        slotsFromOwnedDutiesOnly: false,
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        // --- Tabs
        groupTab: 'general',
        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        consultationsTabChildTab: 'slots',
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */
      }
    },

    // created () {
    // },

    // mounted () {
    // },

    beforeDestroy () {
      this.clear()
    },

    // unmounted () {
    // },

    methods: {
      //
      // GESTÃO DO POPUP + DADOS
      //

      reset () {
        this.isVisible = false
        this.loading = false
        this.presetLocations = false
        this.groupLocations = []

        this.error = {
          name: false,
          local: false,
          maxShifts: false,
          startDay: false,
          endDay: false,
          availableShiftsColor: false,
          ownedShiftsColor: false,
          sameShiftsColor: false,
          availableShiftWhite: false,
          ownedShiftWhite: false,
        }

        this.scaleID = ''
        this.scaleName = ''
        this.scaleLocation = { id: '', name: '' }
        this.scaleValue = 0
        this.scaleWeekdaysHourlyRate = 0
        this.scaleWeekendHourlyRate = 0
        this.scaleDayShiftHourlyRate = 0
        this.scaleNightShiftHourlyRate = 0
        this.scaleWeekdaysDayShiftHourlyRate = 0
        this.scaleWeekdaysNightShiftHourlyRate = 0
        this.scaleWeekendDayShiftHourlyRate = 0
        this.scaleWeekendNightShiftHourlyRate = 0
        this.scaleMaxShifts = 0
        this.startDayOfMonth = 0
        this.endDayOfMonth = 0
        //
        this.allowBreakDuringDuty = false
        //
        this.colorShiftsAvailable = '#00cb72'
        this.colorShiftsOwned = '#2196f3'

        // cd.mixin.js
        this.cdParameters = { title: '', text: '', buttonPosition: 'right', width: 330 }

        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        // -- SOS Portal
        this.scaleConsultationDuration = '0'
        this.requirePatient = true
        // this.requirePatient = '1'
        this.slotsFromOwnedDutiesOnly = false
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        // --- Tabs
        this.groupTab = 'general'
        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        this.consultationsTabChildTab = 'slots'
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */
      },

      clear () {
        this.reset()

        delete this.isVisible
        delete this.loading
        delete this.presetLocations
        delete this.groupLocations
        delete this.error
        delete this.scaleID
        delete this.scaleName
        delete this.scaleLocation
        delete this.scaleValue
        delete this.scaleWeekdaysHourlyRate
        delete this.scaleWeekendHourlyRate
        delete this.scaleDayShiftHourlyRate
        delete this.scaleNightShiftHourlyRate
        delete this.scaleWeekdaysDayShiftHourlyRate
        delete this.scaleWeekdaysNightShiftHourlyRate
        delete this.scaleWeekendDayShiftHourlyRate
        delete this.scaleWeekendNightShiftHourlyRate
        delete this.scaleMaxShifts
        //
        delete this.allowBreakDuringDuty
        //
        delete this.colorShiftsAvailable
        delete this.colorShiftsOwned

        // cd.mixin.js
        delete this.cdParameters

        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        // -- SOS Portal
        delete this.scaleConsultationDuration
        delete this.requirePatient
        delete this.slotsFromOwnedDutiesOnly
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        // --- Tabs
        delete this.groupTab
        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        delete this.consultationsTabChildTab
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */
      },

      open (rawSelectedScale, rawCurrentGroup)
      {
        // console.log('::: EDITAR DETALHES DA ESCALA -> opening:', rawSelectedScale, rawCurrentGroup)

        //
        // Nota do Fernando:
        // "structuredClone" evita qualquer vínculo com o objeto original no componente pai.
        // Percebi essa necessidade de romper vínculo enquanto digitava o NOME DO LOCAL e essa
        // alteração propagava em tempo real para a lista de escalas.
        //

        const selectedScale = structuredClone(rawSelectedScale)
        const currentGroup = structuredClone(rawCurrentGroup)

        this.presetLocations = currentGroup.fixLocais

        this.groupLocations = currentGroup.groupLocations.length > 0 ? currentGroup.groupLocations.map(groupLocation => ({
          key: 'scaleLocation_' + groupLocation.groupPlaceID,
          value: groupLocation.groupPlaceID,
          text: `${groupLocation.groupPlaceName}${groupLocation.isGroupLocationGeofenced ? ` <span class="scLocationStatus" data-active="true"> - Área: ${groupLocation.groupPlaceRadius} metros</span>` : ' <span class="scLocationStatus" data-active="false"> - Área: Desativada</span>'}`,
        })) : []

        this.scaleID = selectedScale.scaleID
        this.scaleName = selectedScale.scaleName
        this.scaleValue = selectedScale.scaleValue ? selectedScale.scaleValue : 0
        this.scaleWeekdaysHourlyRate = selectedScale.scaleWeekdaysHourlyRate ? selectedScale.scaleWeekdaysHourlyRate : 0
        this.scaleWeekendHourlyRate = selectedScale.scaleWeekendHourlyRate ? selectedScale.scaleWeekendHourlyRate : 0
        this.scaleDayShiftHourlyRate = selectedScale.scaleDayShiftHourlyRate ? selectedScale.scaleDayShiftHourlyRate : 0
        this.scaleNightShiftHourlyRate = selectedScale.scaleNightShiftHourlyRate ? selectedScale.scaleNightShiftHourlyRate : 0
        this.scaleWeekdaysDayShiftHourlyRate = selectedScale.scaleWeekdaysDayShiftHourlyRate ? selectedScale.scaleWeekdaysDayShiftHourlyRate : 0
        this.scaleWeekdaysNightShiftHourlyRate = selectedScale.scaleWeekdaysNightShiftHourlyRate ? selectedScale.scaleWeekdaysNightShiftHourlyRate : 0
        this.scaleWeekendDayShiftHourlyRate = selectedScale.scaleWeekendDayShiftHourlyRate ? selectedScale.scaleWeekendDayShiftHourlyRate : 0
        this.scaleWeekendNightShiftHourlyRate = selectedScale.scaleWeekendNightShiftHourlyRate ? selectedScale.scaleWeekendNightShiftHourlyRate : 0
        this.scaleMaxShifts = selectedScale.scaleMaxShifts ? selectedScale.scaleMaxShifts : 0
        this.startDayOfMonth = selectedScale.startDayOfMonth ? selectedScale.startDayOfMonth : 0
        this.endDayOfMonth = selectedScale.endDayOfMonth ? selectedScale.endDayOfMonth : 0

        this.scaleLocation = selectedScale.scaleLocation

        this.allowBreakDuringDuty = selectedScale.allowDutySplitting || false

        this.colorShiftsAvailable = selectedScale.availableShiftsColor
        this.colorShiftsOwned = selectedScale.ownedShiftsColor

        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        this.scaleConsultationDuration = selectedScale.scaleConsultationDuration
        // this.requirePatient = selectedScale.requirePatient ? '1' : '0'
        this.requirePatient = selectedScale.requirePatient
        this.slotsFromOwnedDutiesOnly = selectedScale.slotsFromOwnedDutiesOnly
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        this.setTab()
        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        this.setConsultationsTabChildTab()
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        this.isVisible = true
      },

      close (confirmed = false) {
        this.reset()
        this.$emit('close', confirmed)
      },

      //
      // --- Abas
      //

      setTab (tab = 'general')
      {
        this.groupTab = tab
      },

      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      setConsultationsTabChildTab (tab = 'slots')
      {
        this.consultationsTabChildTab = tab
      },
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */

      //
      //
      //

      openAvailableShiftsColorPicker () {
        this.$refs.dialogAvailableColorPicker.open(this.colorShiftsAvailable)
      },

      openOwnedShiftsColorPicker () {
        this.$refs.dialogOwnedColorPicker.open(this.colorShiftsOwned)
      },

      onAvailableShiftsColorPickerClose (action) {
        if (!!action === false) return false

        this.colorShiftsAvailable = action
      },

      onOwnedShiftsColorPickerClose (action) {
        if (!!action === false) return false

        this.colorShiftsOwned = action
      },

      //
      // FIELD ERROR HANDLING
      //

      resetErrors () {
        this.error.name = false
        this.error.local = false
        this.error.maxShifts = false
        this.error.startDay = false
        this.error.endDay = false
        this.error.availableShiftsColor = false
        this.error.ownedShiftsColor = false
        this.error.sameShiftsColor = false
        this.error.availableShiftWhite = false
        this.error.ownedShiftWhite = false
      },

      getErrors () {
        return this.error
      },

      setError (error, status = true) {
        this.error[error] = status
      },

      //
      // SAVE SCALE
      //

      async saveScale ()
      {
        //
        // SANITIZE/PREPARE SOME DATA
        //

        const scaleName = String(this.scaleName).trim()
        const scaleMaxShifts = Number(this.scaleMaxShifts)
        const startDayOfMonth = Number(this.startDayOfMonth)
        const endDayOfMonth = Number(this.endDayOfMonth)
        const colorShiftsAvailable = String(this.colorShiftsAvailable).toUpperCase()
        const colorShiftsOwned = String(this.colorShiftsOwned).toUpperCase()

        //
        // VALIDATE FIELDS
        //

        this.resetErrors()

        // VERIFICA SE O NOME DA ESCALA FOI PREENCHIDO CORRETAMENTE
        if (!validateScaleName(scaleName)) this.setError('name')

        // VERIFICA SE O LOCAL PERSONALIZADO FOI PREENCHIDO CORRETAMENTE (NOTA: ISSO ACONTECE APENAS SE O GRUPO NÃO TEM LOCAIS PRÉ-DEFINIDOS)
        if (this.presetLocations === false && this.scaleLocation.name.length > 0 && !validateLocationName(this.scaleLocation.name)) this.setError('local')

        // VERIFICA SE EXISTE QUANTIDADE MÁXIMA DE PLANTÕES POR USUÁRIO, SE SIM, DEVE SER MENOR QUE 10000
        if (scaleMaxShifts > 9999) this.setError('maxShifts')

        // VERIFICA SE O DIA DO MÊS DE INÍCIO DO PLANTÃO É VÁLIDO (ENTRE 1 E 31)
        if (startDayOfMonth && (startDayOfMonth < 1 || startDayOfMonth > 31)) this.setError('startDay')

        // VERIFICA SE O DIA DO MÊS DE TÉRMINO DO PLANTÃO É VÁLIDO (ENTRE 1 E 31)
        if (endDayOfMonth && (endDayOfMonth < 1 || endDayOfMonth > 31)) this.setError('endDay')

        // VERIFICA SE O NOME DA ESCALA FOI PREENCHIDO CORRETAMENTE
        // if (!validateScaleName(scaleName)) e.push('Informe um nome contendo entre 1 e 64 caracteres.')
        // VERIFICA SE O LOCAL PERSONALIZADO FOI PREENCHIDO CORRETAMENTE (NOTA: ISSO ACONTECE APENAS SE O GRUPO NÃO TEM LOCAIS PRÉ-DEFINIDOS)
        // if (this.presetLocations === false && this.scaleLocation.name.length > 0 && !validateLocationName(this.scaleLocation.name)) e.push('Limpe o nome do local ou informe um nome entre 3 e 64 caracteres.')
        // VERIFICA SE EXISTE QUANTIDADE MÁXIMA DE PLANTÕES POR USUÁRIO, SE SIM, DEVE SER MENOR QUE 10000
        // if (scaleMaxShifts > 9999) e.push('Limpe a quantidade máxima de plantões ou informe uma quantidade menor que 9999.')

        //  IS AVAILABLE SHIFT HEXADECIMAL COLOR VALID?
        if (!/^#[A-Fa-f0-9]{6}$/i.test(colorShiftsAvailable)) this.setError('availableShiftsColor')
        // VERIFICA SE A COR DOS PLANTÕES DISPONÍVEIS É BRANCO
        if (isLightColor(colorShiftsAvailable, 80)) this.setError('availableShiftWhite')

        //  IS OWNED SHIFT HEXADECIMAL COLOR VALID?
        if (!/^#[A-Fa-f0-9]{6}$/i.test(colorShiftsOwned)) this.setError('ownedShiftsColor')
        // VERIFICA SE A COR DOS PLANTÕES ASSUMIDOS É BRANCO
        if (isLightColor(colorShiftsOwned, 80)) this.setError('ownedShiftWhite')

        // ARE OWNED AND AVAILABLE SHIFTS COLOR THE SAME?
        if (colorShiftsAvailable === colorShiftsOwned) this.setError('sameShiftsColor')

        const { name, local, maxShifts, startDay, endDay, availableShiftsColor, ownedShiftsColor, sameShiftsColor, availableShiftWhite, ownedShiftWhite } = this.getErrors()

        if (name || local || maxShifts || startDay || endDay || availableShiftsColor || ownedShiftsColor || sameShiftsColor || availableShiftWhite || ownedShiftWhite) return false

        //
        // UPDATE
        //

        // console.log('=== ANTES DE SALVAR ESCALA ===')
        // console.log('scaleValue:', this.scaleValue, 'type:', typeof this.scaleValue)
        // console.log('scaleWeekdaysHourlyRate:', this.scaleWeekdaysHourlyRate, 'type:', typeof this.scaleWeekdaysHourlyRate)
        // console.log('scaleWeekendHourlyRate:', this.scaleWeekendHourlyRate, 'type:', typeof this.scaleWeekendHourlyRate)
        // console.log('scaleDayShiftHourlyRate:', this.scaleDayShiftHourlyRate, 'type:', typeof this.scaleDayShiftHourlyRate)
        // console.log('scaleNightShiftHourlyRate:', this.scaleNightShiftHourlyRate, 'type:', typeof this.scaleNightShiftHourlyRate)
        // console.log('scaleWeekdaysDayShiftHourlyRate:', this.scaleWeekdaysDayShiftHourlyRate, 'type:', typeof this.scaleWeekdaysDayShiftHourlyRate)
        // console.log('scaleWeekdaysNightShiftHourlyRate:', this.scaleWeekdaysNightShiftHourlyRate, 'type:', typeof this.scaleWeekdaysNightShiftHourlyRate)
        // console.log('scaleWeekendDayShiftHourlyRate:', this.scaleWeekendDayShiftHourlyRate, 'type:', typeof this.scaleWeekendDayShiftHourlyRate)
        // console.log('scaleWeekendNightShiftHourlyRate:', this.scaleWeekendNightShiftHourlyRate, 'type:', typeof this.scaleWeekendNightShiftHourlyRate)

        this.loading = true

        const requestData = {
          groupID: this.$route.params.groupID,
          scaleID: this.scaleID,

          scaleName,
          scaleLocation: { ...this.scaleLocation, presetLocations: this.presetLocations },
          scaleValue: this.scaleValue,
          weekdaysHourlyRate: this.scaleWeekdaysHourlyRate,
          weekendHourlyRate: this.scaleWeekendHourlyRate,
          dayShiftHourlyRate: this.scaleDayShiftHourlyRate,
          nightShiftHourlyRate: this.scaleNightShiftHourlyRate,
          weekdaysDayShiftHourlyRate: this.scaleWeekdaysDayShiftHourlyRate,
          weekdaysNightShiftHourlyRate: this.scaleWeekdaysNightShiftHourlyRate,
          weekendDayShiftHourlyRate: this.scaleWeekendDayShiftHourlyRate,
          weekendNightShiftHourlyRate: this.scaleWeekendNightShiftHourlyRate,
          scaleMaxShifts,
          startDayOfMonth,
          endDayOfMonth,

          allowBreakDuringDuty: this.allowBreakDuringDuty || null,

          availableShiftsColor: colorShiftsAvailable,
          ownedShiftsColor: colorShiftsOwned,

          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          scaleConsultationDuration: this.scaleConsultationDuration,
          requirePatient: this.requirePatient,
          slotsFromOwnedDutiesOnly: this.slotsFromOwnedDutiesOnly,
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */
        }

        const request = await apiUpdateScale(requestData)

        this.loading = false

        if (request.code === 0) {
          return this.showMessage('Atenção!', request.response)
        }

        //
        // CLOSE DIALOG
        //

        this.close(true)
      },

      //
      // SELECTS EVENTS
      //

      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      onSelectConsultationDuration (value) {
        this.scaleConsultationDuration = value
      },

      onSelectPatientRequiredOption (value) {
        this.requirePatient = value
      },

      onToggleSlotsFromOwnedDutiesOnly (value) {
        this.slotsFromOwnedDutiesOnly = value
      },
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */

      selectedScaleLocation (selectedPlace) {
        const findPlace = this.groupLocations.find(groupPlace => groupPlace.value === selectedPlace)

        // SE O GRUPO NÃO TEM LOCAIS PRÉ-DEFINIDOS, ENTÃO O GESTOR PODE ATRIBUIR UM LOCAL PERSONALIZADO (TEXTO LIVRE)
        // SE O GRUPO TEM LOCAIS PRÉ-DEFINIDOS, ENTÃO O GESTOR SÓ PODE ATRIBUIR UM DESSES LOCAIS

        this.scaleLocation = {
          id: findPlace ? findPlace.value : '',
          name: findPlace ? findPlace.text.split(' <span class="scLocationStatus"')[0] : '',
        }
      },

      onBlurScaleValue (scaleValue) {
        this.scaleValue = scaleValue
      },

      onInputScaleWeekdaysHourlyRate (value) {
        this.scaleWeekdaysHourlyRate = value
      },

      onInputScaleWeekendHourlyRate (value) {
        this.scaleWeekendHourlyRate = value
      },

      onInputScaleDayShiftHourlyRate (value) {
        this.scaleDayShiftHourlyRate = value
      },

      onInputScaleNightShiftHourlyRate (value) {
        this.scaleNightShiftHourlyRate = value
      },

      onInputScaleWeekdaysDayShiftHourlyRate (value) {
        this.scaleWeekdaysDayShiftHourlyRate = value
      },

      onInputScaleWeekdaysNightShiftHourlyRate (value) {
        this.scaleWeekdaysNightShiftHourlyRate = value
      },

      onInputScaleWeekendDayShiftHourlyRate (value) {
        this.scaleWeekendDayShiftHourlyRate = value
      },

      onInputScaleWeekendNightShiftHourlyRate (value) {
        this.scaleWeekendNightShiftHourlyRate = value
      },

      onScaleMaxShiftsChange (inputText) {
        if (!/^\d+$/.test(inputText) || /^0+/.test(inputText)) {
          const newString = inputText.trim().replace(/[^\d]+/g, '').replace(/^0+/, '')
          this.scaleMaxShifts = newString.length > 0 ? newString : '0'
        }
      },

      onScaleStartDayOfMonth (inputText) {
        if (!/^\d+$/.test(inputText) || /^0+/.test(inputText)) {
          const newString = inputText.trim().replace(/[^\d]+/g, '').replace(/^0+/, '')
          this.startDayOfMonth = newString.length > 0 ? newString : '0'
        }
      },

      onScaleEndDayOfMonth (inputText) {
        if (!/^\d+$/.test(inputText) || /^0+/.test(inputText)) {
          const newString = inputText.trim().replace(/[^\d]+/g, '').replace(/^0+/, '')
          this.endDayOfMonth = newString.length > 0 ? newString : '0'
        }
      },

      //
      // GESTÃO DAS CONFIGURAÇÕES DA ESCALA
      //

      onToggleDutyBreak () {
        this.allowBreakDuringDuty = !this.allowBreakDuringDuty
      },

      //
      // CONFIRM DIALOG OUTPUT/RESPONSE
      //

      async cdAction (cdResponse) {
      },
    },
  }

</script>

<!-- <style lang="scss" scoped></style> -->
